import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import permissionsReducer from './permissionsSlice';
import settingsReducer from './settingsSlice';
import financialYearReducer from './financialYearSlice';
import locationReducer from './locationSlice';

const permissionsPersistConfig = {
  key: 'permissions',
  storage,
};
const persistedPermissionsReducer = persistReducer(permissionsPersistConfig, permissionsReducer);

const settingsPersistConfig = {
  key: 'settings',
  storage,
};
const persistedSettingsReducer = persistReducer(settingsPersistConfig, settingsReducer);

const financialYearPersistConfig = {
  key: 'financialYear',
  storage,
};
const persistedFinancialYearReducer = persistReducer(financialYearPersistConfig, financialYearReducer);

const locationPersistConfig = {
  key: 'location',
  storage,
};
const persistedLocationReducer = persistReducer(locationPersistConfig, locationReducer);

export const store = configureStore({
  reducer: {
    permissions: persistedPermissionsReducer,
    settings: persistedSettingsReducer,
    financialYear: persistedFinancialYearReducer,
    location: persistedLocationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST', 
          'persist/REHYDRATE',
          'persist/PAUSE',
          'persist/PURGE',
          'persist/REGISTER'
        ],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;